export default __webpack_public_path__ + "static/media/translate.2b0f7d52.svg";